import React from "react";
import * as yup from "yup";

import {
  Button,
  ButtonTypes,
  CustomForm,
  PageBreak,
  Text,
  TextArea,
  TextColors,
  TextTypes,
} from "@/component-library";
import { getAutomationDataAttr } from "@/utils/automationUtils";

import "../NoteAddendum.styles.scss";

export function AddendumForm({ onCancel, onSubmit }) {
  return (
    <div className="AddendumForm" {...getAutomationDataAttr("note-addendum-form")}>
      <Text className="AddendumForm__title" layout="block" type={TextTypes.heading2}>
        Add Addendum
      </Text>

      <PageBreak color="grey" />

      <CustomForm
        initialValues={{
          addendum: "",
        }}
        onSubmit={onSubmit}
        render={(formikProps) => (
          <>
            <div className="AddendumForm__form">
              <TextArea
                className="AddendumForm__textarea"
                name="addendum"
                onBlur={formikProps.handleBlur}
                onChange={formikProps.handleChange}
                placeholder="Type Comment..."
                testId="note-addendum-comment"
              >
                {formikProps.values.addendum}
              </TextArea>

              {formikProps.errors.addendum && formikProps.touched.addendum && (
                <Text color={TextColors.red} layout="block" type={TextTypes.small}>
                  {formikProps.errors.addendum}
                </Text>
              )}

              <Text className="AddendumForm__cancel--text" color={TextColors.grey} layout="block">
                Addendums will not be saved in drafts
              </Text>
            </div>

            <div className="AddendumForm__buttons">
              <Button
                buttonType={ButtonTypes.primaryOutline}
                className="AddendumForm__cancel"
                onClick={() => {
                  formikProps.resetForm();
                  onCancel();
                }}
              >
                Cancel
              </Button>

              <Button
                buttonType={ButtonTypes.primary}
                className="AddendumForm__submit"
                onClick={formikProps.handleSubmit}
                testId="note-addendum-save"
                type="submit"
              >
                Save
              </Button>
            </div>
          </>
        )}
        validationSchema={yup.object().shape({
          addendum: yup.string().required("Comment is required."),
        })}
      />
    </div>
  );
}
